import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const sharedProps: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	portal: 'SP',
	feature: HubFeature.OtherRequirement,
};

const pathStart = 'Catalogs|Other Requirements|Advanced|Add Group Modal|';

export type SPOtherRequirementsAddGroupModalLocNames =
	| 'SPOtherRequirementsAdvancedModalTitleAddGroup'
	| 'SPOtherRequirementsAdvancedModalLabelName'
	| 'SPOtherRequirementsAdvancedModalButtonCancel'
	| 'SPOtherRequirementsAdvancedModalButtonSave'
	| 'SPOtherRequirementsAdvancedModalErrorNameRequired'
	| 'SPOtherRequirementsAdvancedModalNotificationSuccess'
	| 'SPOtherRequirementsAdvancedModalNotificationFailure';

export const spOtherRequirementsAddGroupModalLocs: LocDefs<SPOtherRequirementsAddGroupModalLocNames> =
	{
		SPOtherRequirementsAdvancedModalTitleAddGroup: {
			defaultValue: 'Add Group',
			description: 'The title of the add group modal.',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalLabelName: {
			defaultValue: 'Name',
			description: 'The label for the name field.',
			displayPath: `${pathStart}Label Name`,
			displayType: 'Label',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalButtonCancel: {
			defaultValue: 'Cancel',
			description: 'The button text for canceling the form.',
			displayPath: `${pathStart}Button Cancel`,
			displayType: 'Button',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalButtonSave: {
			defaultValue: 'Save',
			description: 'The button text for saving the form.',
			displayPath: `${pathStart}Button Save`,
			displayType: 'Button',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalErrorNameRequired: {
			defaultValue: 'Name is required',
			description: 'The error message for the name field.',
			displayPath: `${pathStart}Error Name Required`,
			displayType: 'Error',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalNotificationSuccess: {
			defaultValue: 'Group added successfully',
			description: 'The notification message for adding a group.',
			displayPath: `${pathStart}Notification Success`,
			displayType: 'Notification',
			...sharedProps,
		},
		SPOtherRequirementsAdvancedModalNotificationFailure: {
			defaultValue: 'Failed to add group. Please try again.',
			description: 'The notification message when adding a group fails.',
			displayPath: `${pathStart}Notification Failure`,
			displayType: 'Notification',
			...sharedProps,
		},
	};

export type SPOtherRequirementsAddGroupModalLocType =
	LocMap<SPOtherRequirementsAddGroupModalLocNames>;
